// src/components/CartCheckoutButton.jsx
import React, { useState } from "react";
import stripePromise from "./stripe";

const StripeCheckoutButton = () => {
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      // 1. Request a Session URL from your DRF endpoint
      const response = await fetch(
        "http://127.0.0.1:8000/payments/create-checkout-session/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.getItem("access")}`, // Adjust based on your Auth setup
          },
          body: JSON.stringify({
            purchase_type: "cart", // Tells Django to parse the Cart table
          }),
        },
      );

      const data = await response.json();

      if (response.ok && data.checkout_url) {
        // 2. Redirect the user securely out to Stripe Checkout
        window.location.href = data.checkout_url;
      } else {
        alert(data.error || "Something went wrong launching checkout.");
      }
    } catch (error) {
      console.error("Checkout Error:", error);
      alert("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleCheckout}
      disabled={loading}
      className="checkout-btn"
    >
      {loading ? "Processing..." : "Proceed to Checkout"}
    </button>
  );
};

export default StripeCheckoutButton;
